import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";

import free from "../../assets/images/free.gif";
import BannerSite from "../../assets/images/BANNER_SITE.png";
import Button from "../../Components/Button";


const Title = styled.h1`
  font-weight: 200;
  font-size: 40px;
  margin: 0px;
  color: #ffffff;
  text-align: left;
  margin-bottom: 40px;

  span {
    color: #4162fd;
  }
`;

const InfoCard = styled.div`
  display: flex;
  align-items: center;
  padding: 30px;
  border-radius: 14px;
  background-color: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  margin-bottom: 50px;
`;

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  margin-right: 24px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
`;

const TitleCard = styled.div`
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  color: #000;
`;

const SubtitleCard = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #000;
  margin-top: 4px;
  line-height: 30px;
`;

const Subtitle = styled.div`
  font-size: 20px;
  font-weight: 200;
  line-height: 30px;
  color: #ffffff;
  margin-bottom: 50px;
  text-align: left;
`;

const ResponsiveImage = styled.img`
  width: 100%;
  height: auto;
  float: right;

  /* HD: largura total */
  @media (min-width: 1280px) and (max-width: 1919px) {
    max-width: 100%;
  }

  /* Full HD: 80% */
  @media (min-width: 1920px) {
    max-width: 80%;
  }
`;

const TestFree = () => {

  const redirect = () => {
    window.location.href = "/redirect";
  };
  return (
    <Container
      style={{ textAlign: "center", background: "#000000" }}
      id="section-9"
    >
      <Row
        xs="1fr"
        sm="1fr"
        md="1fr 38%"
        lg="1fr 38%"
        xl="1fr 38%"
        style={{ marginTop: "80px" }}
      >
        <div style={{ marginTop: 50 }}>
          <Title>
            Deixa o{" "}
            <span style={{ color: "#E4DA1B", fontWeight: 600 }}>Alfred</span>{" "}
            cuidar do WhatsApp.
            <br />
            Você cuida do seu negócio.
          </Title>
          <Subtitle>
            Enquanto você organiza pedidos, cria, vende e faz seu trabalho
            acontecer, o Alfred responde no WhatsApp por você.
          </Subtitle>
          <InfoCard>
            <IconWrapper>
              <img src={free} alt="Icon" />
            </IconWrapper>
            <TextContent>
              <TitleCard>Teste gratuitamente por 3 dias</TitleCard>
              <SubtitleCard>
                Sem cartão de crédito. Sem risco. Só para você sentir a diferença.
              </SubtitleCard>
            </TextContent>
          </InfoCard>
          <Button onClick={() => {redirect()}} style={{width: '257px', margin: 'auto', color: "#000"}}>
            Começar agora
          </Button>
          <br/>
        </div>
        <div>
          <ResponsiveImage src={BannerSite} alt="banner" />
        </div>
      </Row>
    </Container>
  );
};

export default TestFree;
